export default __webpack_public_path__ + "static/media/294.75ae5af8.svg";